import { useMemo, useState } from "react";
import { comicCategories, comicSeries } from "@/mocks/comic";

const tabs = ["全部", ...comicCategories.map((c) => c.name)];

export default function Featured() {
  const [active, setActive] = useState("全部");

  const list = useMemo(
    () => (active === "全部" ? comicSeries : comicSeries.filter((c) => c.genre === active)),
    [active],
  );

  return (
    <section id="featured" className="bg-background-50">
      <div className="container-paper py-14 md:py-20">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.18em] text-primary-600">
              <i className="ri-fire-line text-sm leading-none" aria-hidden="true"></i>
              热门漫画
            </span>
            <h2 className="mt-3 font-display text-3xl text-foreground-950 md:text-4xl">
              最近都在翻的旧刊
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-600">
              人气与口碑兼具的复古漫画系列，点进去就能体会到纸上的张力与细节。
            </p>
          </div>
        </div>

        {/* 分类切换 */}
        <div className="mt-8 flex flex-wrap gap-2">
          {tabs.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setActive(t)}
              className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                active === t
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        {/* 漫画卡片 */}
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((c) => (
            <article
              key={c.id}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-transform duration-300 hover:-translate-y-1"
            >
              <a href="#reading" className="block" aria-label={`阅读《${c.title}》`}>
                <div className="relative aspect-[440/600] overflow-hidden">
                  <img
                    src={c.cover}
                    alt={`《${c.title}》复古纸质漫画封面`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute left-3 top-3 flex items-center gap-2">
                    <span className="rounded-md bg-primary-600/90 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
                      {c.genre}
                    </span>
                    {c.status === "热读" && (
                      <span className="flex items-center gap-1 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                        <i className="ri-fire-fill text-sm leading-none" aria-hidden="true"></i>
                        热读
                      </span>
                    )}
                  </div>
                  <div className="absolute right-3 top-3 rounded-md bg-foreground-950/80 px-2.5 py-1 text-xs font-medium text-accent-300 backdrop-blur-sm">
                    ★ {c.score}
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-display text-xl text-foreground-950">{c.title}</h3>
                  <p className="mt-1 text-xs text-foreground-500">
                    {c.author} · {c.chapters}
                  </p>
                  <p className="mt-3 text-sm leading-6 text-foreground-600 line-clamp-2">
                    {c.desc}
                  </p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4">
                    <span className="text-xs text-foreground-400">{c.status}</span>
                    <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                      试读
                      <i className="ri-arrow-right-line text-base leading-none" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}